import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";

function DeliveryChallanItemUpdate() {
  const [visible, setvisible] = useState(true);
  const { id } = useParams();
  const { dcID } = useParams();
  const { delivery_challan_type_id } = useParams();
  const location = useLocation();
  const customer_id = location.state?.customer_id;
  let navigate = useNavigate();

  useEffect(() => {
    getDeliveryChallenItem();
  }, []);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  // console.log(erplist);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.update
  );

  const deliveryChallanItem = { id: id };
  const getDeliveryChallenItem = () => {
    axios
      .post(
        "/api/purple-fusion/delivarychallanitem/get",
        deliveryChallanItem,
        headers
      )
      .then((response) => {
        const newData = response.data[0];
        console.log(response.data);
        formik.setValues((prevValues) => {
          return {
            ...prevValues,
            ...newData,
          };
        });
      })
      .catch((error) => {
        console.error("Error fetching Customer contact data:", error);
      });
  };
  const validationSchema = Yup.object().shape({
    quantity: Yup.string().required(" Quantity is required "),
    cost_price: Yup.string().required("Cost Price is required "),
    isactive: Yup.string().required(" isActive is required "),
  });
  const formik = useFormik({
    initialValues: {
      id: id,
      quantity: "",
      cost_price: "",
      isactive: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleFormSubmit = (values) => {
    // console.log(values);
    axios
      .put("/api/purple-fusion/delivarychallanitem/update", values, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);

                navigate(
                  `/delivarychallanitem/list/${dcID}/${delivery_challan_type_id}/${customer_id}`
                );
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        setvisible(false);

        navigate("*");
      });
  };
  const customStyle = {
    content: {
      width: "70%",
      height: "80%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };
  return (
    <div>
      {showActionColumn ? (
        <div>
          <Modal isOpen={visible} style={customStyle}>
            <form onSubmit={formik.handleSubmit}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[10px] justify-start md:px-5 w-full">
                    <div className="flex flex-row w-[100%]  ml-2">
                      <div className="flex flex-row sm:gap-15 items-center justify-start w-full ">
                        <Text
                          className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] "
                          size="txtInterMedium24"
                        >
                          Update Items
                        </Text>
                      </div>
                      <div className="flex flex-row items-center  justify-end  ">
                        <Button
                          className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]  active:scale-90 transition-transform duration-200"
                          shape="round"
                          color="blue_A700"
                          size="base"
                          variant="fill"
                          type="submit"
                        >
                          Save
                        </Button>
                        <Button
                          className="cursor-pointer sticky font-small mb-3 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                          shape="round"
                          color="white"
                          size="base"
                          variant="fill"
                          onClick={() => {
                            setvisible(false);
                            navigate(
                              `/delivarychallanitem/list/${dcID}/${delivery_challan_type_id}/${customer_id}`
                            );
                          }}
                        >
                          ╳
                        </Button>
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full  ">
                      <ToastContainer />
                      <div className="flex flex-col items-center justify-start  w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto "
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Item Name
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>

                            <input
                              name="item_detail_id"
                              type="text"
                              readOnly
                              placeholder=" Enter Descreption"
                              value={formik.values.itemname}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>

                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Item Description
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="item_description"
                              type="text"
                              readOnly
                              placeholder=" Enter Description"
                              value={formik.values.item_description}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                SAC Code
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="sac_code"
                              type="text"
                              placeholder=" Enter SAC code"
                              readOnly
                              value={
                                formik.values.sac_code
                                  ? formik.values.sac_code
                                  : "NA"
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>

                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                HSN Code
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="hsn_code"
                              type="text"
                              placeholder=" Enter hsn code"
                              readOnly
                              // value={formik.values.hsn_code}
                              value={
                                formik.values.hsn_code
                                  ? formik.values.hsn_code
                                  : "NA"
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Quantity
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="quantity"
                              type="text"
                              placeholder=" Enter quantity "
                              value={formik.values.quantity}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                            {formik.touched.quantity &&
                            formik.errors.quantity ? (
                              <div className="text-red-500">
                                {formik.errors.quantity}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Cost Price
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="cost_price"
                              type="text"
                              placeholder=" Enter Cost price"
                              value={formik.values.cost_price}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                          {formik.touched.cost_price &&
                          formik.errors.cost_price ? (
                            <div className="text-red-500">
                              {formik.errors.cost_price}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Item Amount
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="item_amount"
                              type="text"
                              placeholder=" Enter item amount"
                              readOnly
                              value={
                                formik.values.quantity *
                                formik.values.cost_price
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                SGST Percentage
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="sgst_percentage"
                              type="text"
                              placeholder=" Enter sgst percentage"
                              readOnly
                              value={formik.values.sgst_percentage}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                CGST Percentage
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="cgst_percentage"
                              type="text"
                              placeholder="Enter cgst percentage"
                              readOnly
                              value={formik.values.cgst_percentage}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                IGST Percentage
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="igst_percentage"
                              type="text"
                              placeholder=" Enter igst percentage"
                              readOnly
                              value={formik.values.igst_percentage}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                SGST Amount
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="sgst_amount"
                              type="text"
                              placeholder=" Enter sgst amount "
                              readOnly
                              value={
                                (formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.sgst_percentage) /
                                100
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                CGST Amount
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="cgst_amount"
                              type="text"
                              placeholder=" Enter cgst amount"
                              readOnly
                              value={
                                (formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.cgst_percentage) /
                                100
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                IGST Amount
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="igst_amount"
                              type="text"
                              placeholder=" Enter igst amount "
                              readOnly
                              value={
                                (formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.igst_percentage) /
                                100
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Total Tax
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="total_tax"
                              type="text"
                              placeholder=" Enter total tax"
                              readOnly
                              value={
                                (formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.sgst_percentage) /
                                  100 +
                                (formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.cgst_percentage) /
                                  100 +
                                (formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.igst_percentage) /
                                  100
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Total Amount
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="total_amount"
                              type="text"
                              placeholder=" Enter Total Amount "
                              readOnly
                              value={
                                formik.values.quantity *
                                  formik.values.cost_price +
                                ((formik.values.quantity *
                                  formik.values.cost_price *
                                  formik.values.sgst_percentage) /
                                  100 +
                                  (formik.values.quantity *
                                    formik.values.cost_price *
                                    formik.values.cgst_percentage) /
                                    100 +
                                  (formik.values.quantity *
                                    formik.values.cost_price *
                                    formik.values.igst_percentage) /
                                    100)
                              }
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                            ></input>
                          </div>
                        </div>
                      </div>

                      {/* <div className="flex flex-col items-center justify-start mt-4 w-full  ">
                        <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                          <div className="flex flex-col gap-[16px] items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small">
                                Active
                              </span>
                              <span className="text-red-A700 font-inter font-small">
                                *
                              </span>
                            </Text>
                            <form>
                              <div style={{ display: "flex" }}>
                                <input
                                  className="mr-1"
                                  type="radio"
                                  id="yes"
                                  name="isactive"
                                  value="true"
                                  checked={formik.values.isactive === true}
                                  onChange={() => {
                                    formik.handleChange({
                                      target: {
                                        name: "isactive",
                                        value: !formik.values.isactive, // Toggle the value
                                      },
                                    });
                                  }}
                                />
                                <label className="ml-1 mr-5" htmlFor="yes">
                                  <b>YES</b>
                                </label>
                                <br />
                                <input
                                  className="mr-1"
                                  type="radio"
                                  id="no"
                                  name="isactive"
                                  value="false"
                                  checked={formik.values.isactive === false}
                                  onChange={() => {
                                    formik.handleChange({
                                      target: {
                                        name: "isactive",
                                        value: !formik.values.isactive, // Toggle the value
                                      },
                                    });
                                  }}
                                />
                                <label className="ml-2" htmlFor="no">
                                  <b>NO</b>
                                </label>
                              </div>
                            
                            </form>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </div>
  );
}

export default DeliveryChallanItemUpdate;
